"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HearingSchema = void 0;
const tslib_1 = require("tslib");
const zod_1 = tslib_1.__importDefault(require("zod"));
const case_schemas_1 = require("./case.schemas");
const joda_schemas_1 = require("./joda.schemas");
exports.HearingSchema = zod_1.default.object({
    id: zod_1.default.string().uuid(),
    hearingSections: zod_1.default.array(case_schemas_1.HearingSectionSchema),
    recordingDate: joda_schemas_1.LocalDateSchema,
    recordingId: zod_1.default.string().uuid(),
    locationId: zod_1.default.string().uuid().nullable(),
});
